import { IllustrationSvg as e } from "./Illustration.styled.mjs";
import { renderIllNode as t } from "./renderIllNode.mjs";
import "react";
import { jsx as n } from "react/jsx-runtime";
import { ILL_SCENES as r, ILL_VIEW_BOX as i } from "@maat/assets";
//#region src/components/Illustration/Illustration.tsx
var a = {
	sm: 96,
	md: 132,
	lg: 180
}, o = ({ name: o, size: s = "md", motion: c = !0, className: l }) => {
	let u = r[o];
	if (!u) return null;
	let d = typeof s == "number" ? s : a[s], f = [c ? "mo" : void 0, l].filter(Boolean).join(" ");
	return /* @__PURE__ */ n(e, {
		viewBox: `0 0 ${i.width} ${i.height}`,
		width: d,
		height: d * (i.height / i.width),
		className: f || void 0,
		"aria-hidden": "true",
		focusable: "false",
		children: u().map(t)
	});
};
//#endregion
export { a as ILLUSTRATION_SIZES, o as Illustration };
